import React from 'react';
import { IFlagsConfig } from '@/models';
import { useSelector } from 'react-redux';
import styles from './BlockingStatusToggle.module.scss';
import { ReactComponent as BlockingIcon } from '@/assets/icons/misc/blocking.svg';
import { Trans } from 'react-i18next';
import { EToggleSize, Toggle } from '@/components/common/Toggle/Toggle';
import { selectFlagsConfig } from '@/store/selectors';
import { useFlagsConfig } from '@/hooks/config/useFlagsConfig.hook';

export const BlockingStatusToggle: React.FC = () => {
  const flagsConfig: IFlagsConfig = useSelector(selectFlagsConfig);

  const flagsConfigHook = useFlagsConfig();

  const onToggleChange = async () => {
    await flagsConfigHook.updateSingleFlag(
      'isBlockingEnable',
      !flagsConfig.isBlockingEnable
    );
  };

  return (
    <div className={styles.blockingStatusWrapper}>
      <div className={styles.leftSide}>
        <BlockingIcon className={styles.blockingStatusIcon} />
        <div className={styles.blockingStatusText}>
          <Trans i18nKey={'blocking'} />
        </div>
      </div>
      <div>
        <Toggle
          checked={flagsConfig.isBlockingEnable}
          size={EToggleSize.md}
          onChange={onToggleChange}
        />
      </div>
    </div>
  );
};
